import takeRight from 'lodash/takeRight'

export const getCurrentDomain = () => takeRight(window.location.host.split('.'), 2).join('.')
